(function ($) {
  // Fetch all the forms we want to apply custom Bootstrap validation styles to
  var forms = document.querySelectorAll(".needs-validation");

  // Loop over them and prevent submission
  Array.prototype.slice.call(forms).forEach(function (form) {
    form.addEventListener(
      "submit",
      function (event) {
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        }

        form.classList.add("was-validated");
      },
      false
    );
  });
})(jQuery);

// custom form pagination js
(function ($) {
  $(document).ready(function () {
    // console.log("custom form pagination js");

    const form = $("form.pre-order-form");
    if (form.length > 0) {
      const formId = form.attr("id").replace(/[^0-9]/g, "");

      // Use the form variable to select only the stepIndicator within .pre-order-form
      const stepIndicator = $(".form-step-indicator");

      const currentPageInput = $(
        `input[name="gform_source_page_number_${formId}"]`
      );
      const currentPage = parseInt(currentPageInput.val());
      const totalSteps = stepIndicator.children("li").length; // Total number of steps

      // console.log(form, stepIndicator, currentPage);

      stepIndicator.find("li.current").removeClass("current");

      // Set active and completed step on page load
      stepIndicator.each(function () {
        $(this)
          .children("li")
          .each(function (index) {
            // console.log("index", index);

            if (index + 1 < currentPage) {
              $(this).addClass("complete");
              // console.log("completed", $(this));
            } else if (index + 1 == currentPage) {
              $(this).addClass("current");
              // console.log("current", $(this));
            }
          });
      });

      // If not on the last step, modify the .gform-next-button text
      if (currentPage < totalSteps) {
        let nextStep = currentPage + 1;
        let nextStepLabel = stepIndicator
          .children("li")
          .eq(nextStep - 1)
          .text()
          .trim()
          .substring(1);

        // Use the form variable to select only the .gform_next_button within .pre-order-form
        // if window is larger than 768px
        if ($(window).width() > 768) {
          form
            .find(".gform_next_button")
            .val(`Step ${nextStep}: ${nextStepLabel}`);
        } else {
          form.find(".gform_next_button").val(`${nextStepLabel}`);
        }
      }

      // Progress form using the custom next button
      // $(".form-next").on("click", function (e) {
      //   e.preventDefault();
      //   $("#gform_target_page_number_23").val("2");
      //   $("#gform_23").trigger("submit",[true]);
      //   console.log("form-next");
      // });

      // Navigate to a step when clicked on
      // stepIndicator.children("li").on("click", function () {
      //   const targetStep = $(this).index() + 1;

      //   if (targetStep <= currentPage) {
      //     form.find('input[name="gform_page_number"]').val(targetStep);
      //     form.submit();
      //   }
      // });
    }
  });
})(jQuery);
